import { TUserProfile } from "@/types/user-profile";
import api from "../../utils/api";

export type TUserProfileResponse = {
  data: TUserProfile;
};

export const fetchUserProfile = async (
  uid: string,
): Promise<TUserProfileResponse> => {
  const response = await api.get(`/?uid=${uid}`);
  return response;
};
